import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllStoresSectionComponent } from '@client-monorepo/daily-fintech/stores';
import { CategoriesMiniViewComponent } from '../categories-mini-view/categories-mini-view.component';
import { Banner, BannerCategory, SharedCommonBannersComponent } from '@client-monorepo/libs/shared/common/banners';
import { BackHandlerService } from '@client-monorepo/back-handler';
import { Router } from '@angular/router';
import { ScrolledToEndDirective } from '@client-monorepo/common/utilities';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';

@Component({
  selector: 'stores-applet-online-stores',
  standalone: true,
  imports: [
    CommonModule,
    AllStoresSectionComponent,
    CategoriesMiniViewComponent,
    SharedCommonBannersComponent,
    ScrolledToEndDirective,
    NgxSkeletonLoadingComponent,
  ],
  templateUrl: './online-stores.component.html',
  styleUrl: './online-stores.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnlineStoresComponent {
  BannerCategory = BannerCategory;
  bannersData = input<Banner[]>([]);
  backHandler = inject(BackHandlerService);
  router = inject(Router);
}
